import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { communityPosts, type CommunityPost } from '../../mocks/community';
import { adminStore } from '../../store/adminStore';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const ROLE_LABELS: Record<CommunityPost['authorRole'], string> = {
  student: 'Học sinh',
  teacher: 'Giáo viên',
  parent: 'Phụ huynh'
};

const ROLE_COLORS: Record<CommunityPost['authorRole'], string> = {
  student: 'bg-primary-yellow/20 text-primary-brown',
  teacher: 'bg-primary-orange/20 text-primary-orange',
  parent: 'bg-green-100 text-green-700'
};

type ActiveFilter = 'all' | CommunityPost['authorRole'];

interface Comment {
  id: string;
  authorName: string;
  authorRole: 'student' | 'teacher' | 'parent';
  authorAvatar: string;
  content: string;
  createdAt: string;
}

const SEED_COMMENTS: Record<string, Comment[]> = {
  "1": [
    {
      id: "c1-1",
      authorName: "Thầy Phạm Minh Khoa",
      authorRole: "teacher",
      authorAvatar: "https://readdy.ai/api/search-image?query=Cute%20chibi%20portrait%20of%20kind%20Vietnamese%20man%20teacher%2C%20warm%20smile%2C%20glasses%2C%20simple%20round%20face%2C%20kawaii%20style%2C%20small%20icon%20size%2C%20cream%20background&width=80&height=80&seq=cmt-av1&orientation=squarish",
      content: "Lớp tôi cũng rất thích trò kéo co! Hôm nay các em còn tự nghĩ thêm luật chơi mới nữa 😄",
      createdAt: "1 giờ trước"
    },
    {
      id: "c1-2",
      authorName: "Em Bùi Thị Lan",
      authorRole: "student",
      authorAvatar: "https://readdy.ai/api/search-image?query=Cute%20chibi%20portrait%20of%20young%20Vietnamese%20girl%20student%2C%20cheerful%20smile%2C%20school%20uniform%2C%20simple%20round%20face%2C%20kawaii%20style%2C%20small%20icon%20size%2C%20cream%20background&width=80&height=80&seq=cmt-av2&orientation=squarish",
      content: "Em được xem clip thầy hướng dẫn, trông vui lắm ạ! Em cũng muốn thử!",
      createdAt: "45 phút trước"
    },
    {
      id: "c1-3",
      authorName: "Chị Hoàng Thị Mai",
      authorRole: "parent",
      authorAvatar: "https://readdy.ai/api/search-image?query=Cute%20chibi%20portrait%20of%20Vietnamese%20woman%20parent%2C%20gentle%20smile%2C%20casual%20clothes%2C%20simple%20round%20face%2C%20kawaii%20style%2C%20small%20icon%20size%2C%20cream%20background&width=80&height=80&seq=cmt-av3&orientation=squarish",
      content: "Nhìn ảnh mà thấy các con vui quá! Cảm ơn cô đã tổ chức hoạt động ý nghĩa như vậy ạ.",
      createdAt: "30 phút trước"
    }
  ],
  "2": [
    {
      id: "c2-1",
      authorName: "Cô Lê Thị Thu",
      authorRole: "teacher",
      authorAvatar: "https://readdy.ai/api/search-image?query=Cute%20chibi%20portrait%20of%20Vietnamese%20woman%20teacher%2C%20soft%20smile%2C%20glasses%2C%20simple%20round%20face%2C%20kawaii%20style%2C%20small%20icon%20size%2C%20cream%20background&width=80&height=80&seq=cmt-av4&orientation=squarish",
      content: "Tuấn học tiến bộ lắm! Tiếp tục phát huy em nhé!",
      createdAt: "20 giờ trước"
    },
    {
      id: "c2-2",
      authorName: "Em Đinh Văn An",
      authorRole: "student",
      authorAvatar: "https://readdy.ai/api/search-image?query=Cute%20chibi%20portrait%20of%20young%20Vietnamese%20boy%20student%2C%20big%20smile%2C%20school%20uniform%2C%20simple%20round%20face%2C%20kawaii%20style%2C%20small%20icon%20size%2C%20cream%20background&width=80&height=80&seq=cmt-av5&orientation=squarish",
      content: "Bạn Tuấn ơi, bạn chơi trò nào rồi? Kể cho tớ nghe với!",
      createdAt: "15 giờ trước"
    }
  ],
  "3": [
    {
      id: "c3-1",
      authorName: "Cô Nguyễn Thị Hoa",
      authorRole: "teacher",
      authorAvatar: "https://readdy.ai/api/search-image?query=Cute%20chibi%20portrait%20of%20kind%20Vietnamese%20woman%20teacher%2C%20warm%20smile%2C%20traditional%20teaching%20clothes%2C%20simple%20round%20face%2C%20kawaii%20style%2C%20small%20icon%20size%2C%20cream%20background&width=80&height=80&seq=avatar1&orientation=squarish",
      content: "Gia đình bạn thật đáng yêu! Đây chính là ý nghĩa sâu xa của những trò chơi dân gian — kết nối các thế hệ lại với nhau.",
      createdAt: "2 ngày trước"
    },
    {
      id: "c3-2",
      authorName: "Em Đinh Văn Tuấn",
      authorRole: "student",
      authorAvatar: "https://readdy.ai/api/search-image?query=Cute%20chibi%20portrait%20of%20young%20Vietnamese%20boy%20student%2C%20cheerful%20smile%2C%20school%20uniform%2C%20soft%20warm%20colors%2C%20simple%20round%20face%2C%20kawaii%20style%2C%20small%20icon%20size%2C%20cream%20background&width=80&height=80&seq=avatar2&orientation=squarish",
      content: "Ông bà nhà em cũng từng chơi ô ăn quan hồi nhỏ! Em muốn chơi cùng ông bà luôn.",
      createdAt: "2 ngày trước"
    },
    {
      id: "c3-3",
      authorName: "Chị Trần Thị Bình",
      authorRole: "parent",
      authorAvatar: "https://readdy.ai/api/search-image?query=Cute%20chibi%20portrait%20of%20Vietnamese%20woman%20mother%2C%20gentle%20warm%20smile%2C%20casual%20clothes%2C%20soft%20warm%20colors%2C%20simple%20round%20face%2C%20kawaii%20style%2C%20small%20icon%20size%2C%20cream%20background&width=80&height=80&seq=avatar3&orientation=squarish",
      content: "Cảm ơn mọi người đã ủng hộ! Tuần sau gia đình mình lại chơi tiếp 😊",
      createdAt: "1 ngày trước"
    }
  ]
};

export default function CommunityPage() {
  const isAdmin = adminStore.isAuthenticated();
  const [likedPosts, setLikedPosts] = useState<Set<string>>(new Set());
  const [activeFilter, setActiveFilter] = useState<ActiveFilter>('all');
  const [showShareModal, setShowShareModal] = useState(false);
  const [showTeacherModal, setShowTeacherModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [allPosts, setAllPosts] = useState<CommunityPost[]>(() => {
    const { hiddenPostIds } = adminStore.getStore();
    return communityPosts.filter((p) => !hiddenPostIds.includes(p.id));
  });

  // Đồng bộ ẩn/hiện bài khi admin thay đổi
  useEffect(() => {
    const handler = () => {
      const { hiddenPostIds } = adminStore.getStore();
      setAllPosts(prev => {
        // Re-filter mock posts based on current hidden list, keep user-added posts
        const mockIds = communityPosts.map(p => p.id);
        const userPosts = prev.filter(p => !mockIds.includes(p.id));
        const visibleMockPosts = communityPosts.filter(p => !hiddenPostIds.includes(p.id));
        return [...visibleMockPosts, ...userPosts];
      });
    };
    window.addEventListener('bahnar-admin-updated', handler);
    return () => window.removeEventListener('bahnar-admin-updated', handler);
  }, []);
  const [commentPostId, setCommentPostId] = useState<string | null>(null);
  const [allComments, setAllComments] = useState<Record<string, Comment[]>>(SEED_COMMENTS);
  const [editPostId, setEditPostId] = useState<string | null>(null);
  const [deleteConfirmId, setDeleteConfirmId] = useState<string | null>(null);
  const navigate = useNavigate();

  const toggleLike = (id: string) => {
    setLikedPosts(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const handleTeacherClick = () => {
    setShowTeacherModal(true);
  };

  const handleAddPost = (post: CommunityPost) => {
    setAllPosts(prev => [...prev, post]);
  };

  const handleOpenComments = (postId: string) => {
    setCommentPostId(postId);
  };

  const handleAddComment = (postId: string, comment: Comment) => {
    setAllComments(prev => ({
      ...prev,
      [postId]: [...(prev[postId] || []), comment]
    }));
  };

  const handleDeletePost = (postId: string) => {
    setAllPosts(prev => prev.filter(p => p.id !== postId));
    setDeleteConfirmId(null);
  };

  const handleEditPost = (postId: string, newContent: string) => {
    setAllPosts(prev => prev.map(p =>
      p.id === postId ? { ...p, content: newContent } : p
    ));
    setEditPostId(null);
  };

  const filtered = allPosts
    .filter(p => activeFilter === 'all' || p.authorRole === activeFilter)
    .filter(p =>
      searchQuery.trim() === '' ||
      p.content.toLowerCase().includes(searchQuery.toLowerCase()) ||
      p.authorName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      p.tags.some(t => t.toLowerCase().includes(searchQuery.toLowerCase()))
    );

  const activeCommentPost = commentPostId ? allPosts.find(p => p.id === commentPostId) : null;
  const activeCommentsList = commentPostId ? (allComments[commentPostId] || []) : [];
  const editPost = editPostId ? allPosts.find(p => p.id === editPostId) : null;

  return (
    <div className="min-h-screen bg-primary-cream">
      <Header />

      {/* Hero */}
      <section className="relative pt-28 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Bahnar%20ethnic%20minority%20village%20landscape%20with%20traditional%20stilt%20houses%20wooden%20structures%20and%20lush%20green%20tropical%20hills%2C%20warm%20golden%20light%2C%20soft%20earthy%20tones%2C%20peaceful%20highland%20atmosphere%2C%20artistic%20painterly%20style%2C%20muted%20warm%20colors%2C%20cultural%20heritage%20scenery%20Vietnam&width=1400&height=500&seq=community-hero-bg&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-primary-brown/75 via-primary-orange/60 to-primary-cream/95"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full mb-5">
            <i className="ri-earth-fill text-white"></i>
            <span className="text-sm font-bold text-white uppercase tracking-wider">Cộng đồng</span>
          </div>
          <h1
            className="text-7xl font-extrabold text-white mb-5 leading-tight"
            style={{
              textShadow: '0 0 30px rgba(60,20,0,0.9), 0 4px 24px rgba(100,30,0,0.8), 2px 2px 0 rgba(0,0,0,0.5)',
              WebkitTextStroke: '0.5px rgba(255,255,255,0.15)'
            }}
          >
            Cùng nhau khám phá<br />văn hóa Bahnar
          </h1>
          <p
            className="text-2xl font-semibold text-white max-w-2xl mx-auto"
            style={{ textShadow: '0 2px 16px rgba(80,20,0,0.75), 0 0 20px rgba(60,10,0,0.6)' }}
          >
            Nơi giáo viên, học sinh và phụ huynh chia sẻ trải nghiệm, thành tích và những điều thú vị về văn hóa Bahnar.
          </p>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-3 gap-10">
          {/* Main feed */}
          <div className="lg:col-span-2 space-y-6">

            {/* Inline Share Box */}
            <div className="bg-white rounded-3xl p-5 flex items-center gap-4">
              <div className="w-11 h-11 flex-shrink-0 rounded-full bg-primary-orange/20 flex items-center justify-center">
                <i className="ri-user-smile-fill text-xl text-primary-orange"></i>
              </div>
              <button
                onClick={() => setShowShareModal(true)}
                className="flex-1 text-left px-5 py-3 bg-primary-cream rounded-full text-base text-primary-brown-light hover:bg-primary-orange/10 transition-colors cursor-pointer whitespace-nowrap"
              >
                Bạn muốn chia sẻ khoảnh khắc gì hôm nay?
              </button>
              <button
                onClick={() => setShowShareModal(true)}
                className="flex-shrink-0 px-5 py-2 bg-gradient-to-r from-primary-orange to-primary-yellow text-white text-sm font-bold rounded-full hover:opacity-90 transition-all cursor-pointer whitespace-nowrap"
              >
                Đăng
              </button>
            </div>

            {/* Filter Tabs */}
            <div className="flex items-center bg-primary-orange/10 rounded-2xl p-1 gap-0">
              {(['all', 'student', 'teacher', 'parent'] as ActiveFilter[]).map((val, idx) => {
                const labels: Record<ActiveFilter, string> = {
                  all: 'Tất cả', student: 'Học sinh', teacher: 'Giáo viên', parent: 'Phụ huynh'
                };
                return (
                  <div key={val} className="flex items-center flex-1">
                    {idx > 0 && (
                      <div className={`w-px h-5 bg-primary-orange/30 flex-shrink-0 ${activeFilter === val || activeFilter === (['all', 'student', 'teacher', 'parent'] as ActiveFilter[])[idx - 1] ? 'opacity-0' : 'opacity-100'}`}></div>
                    )}
                    <button
                      onClick={() => setActiveFilter(val)}
                      className={`flex-1 py-2 px-4 rounded-xl text-base font-semibold whitespace-nowrap transition-all cursor-pointer ${
                        activeFilter === val
                          ? 'bg-primary-orange text-white shadow-sm'
                          : 'text-primary-brown hover:text-primary-orange'
                      }`}
                    >
                      {labels[val]}
                    </button>
                  </div>
                );
              })}
            </div>

            {/* Posts */}
            {filtered.length === 0 ? (
              <div className="text-center py-16 text-primary-brown-light text-lg">
                Không tìm thấy bài đăng nào.
              </div>
            ) : filtered.map(post => (
              <article key={post.id} className="bg-white rounded-3xl p-6">
                <div className="flex items-center gap-4 mb-5">
                  <img
                    src={post.authorAvatar}
                    alt={post.authorName}
                    className="rounded-full object-cover object-top"
                    style={{ width: 52, height: 52 }}
                  />
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <span className="font-bold text-primary-brown-dark text-base">{post.authorName}</span>
                      <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${ROLE_COLORS[post.authorRole]}`}>
                        {ROLE_LABELS[post.authorRole]}
                      </span>
                    </div>
                    <p className="text-sm text-primary-brown-light mt-0.5">{post.createdAt}</p>
                  </div>
                  {/* Edit/Delete buttons — only visible to admin (nhà sáng lập) */}
                  {isAdmin && (
                    <div className="flex items-center gap-2">
                      <button
                        onClick={() => setEditPostId(post.id)}
                        className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary-orange/10 text-primary-brown-light hover:text-primary-orange transition-colors cursor-pointer"
                        title="Chỉnh sửa bài đăng"
                      >
                        <i className="ri-edit-2-line text-base"></i>
                      </button>
                      <button
                        onClick={() => setDeleteConfirmId(post.id)}
                        className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-red-50 text-primary-brown-light hover:text-red-500 transition-colors cursor-pointer"
                        title="Xóa bài đăng"
                      >
                        <i className="ri-delete-bin-line text-base"></i>
                      </button>
                    </div>
                  )}
                </div>

                <p className="text-primary-brown leading-relaxed mb-5 text-base">{post.content}</p>

                {post.image && (
                  <img
                    src={post.image}
                    alt="Hình ảnh bài đăng"
                    className="w-full h-64 object-cover object-top rounded-2xl mb-5"
                  />
                )}

                <div className="flex items-center gap-6 pt-4 border-t border-primary-brown-light/10">
                  <button
                    onClick={() => toggleLike(post.id)}
                    className={`flex items-center gap-2 text-base font-medium transition-colors cursor-pointer ${
                      likedPosts.has(post.id) ? 'text-red-500' : 'text-primary-brown-light hover:text-red-500'
                    }`}
                  >
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className={likedPosts.has(post.id) ? 'ri-heart-fill' : 'ri-heart-line'}></i>
                    </div>
                    {post.likes + (likedPosts.has(post.id) ? 1 : 0)}
                  </button>
                  <button
                    onClick={() => handleOpenComments(post.id)}
                    className="flex items-center gap-2 text-base font-medium text-primary-brown-light hover:text-primary-orange transition-colors cursor-pointer"
                  >
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-chat-1-line"></i>
                    </div>
                    {(allComments[post.id]?.length ?? post.comments)} bình luận
                  </button>
                </div>
              </article>
            ))}
          </div>

          {/* Sidebar */}
          <aside className="space-y-6">

            {/* Search */}
            <div className="bg-white rounded-3xl p-5">
              <h3 className="text-base font-bold text-primary-brown-dark mb-3 flex items-center gap-2">
                <div className="w-7 h-7 flex items-center justify-center">
                  <i className="ri-search-line text-primary-orange text-lg"></i>
                </div>
                Tìm kiếm bài đăng
              </h3>
              <div className="relative">
                <div className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-primary-brown-light pointer-events-none">
                  <i className="ri-search-line text-base"></i>
                </div>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={e => setSearchQuery(e.target.value)}
                  placeholder="Nhập tên, nội dung, hashtag..."
                  className="w-full pl-9 pr-4 py-2.5 rounded-xl bg-primary-cream border border-primary-brown-light/20 text-sm text-primary-brown-dark placeholder-primary-brown-light focus:outline-none focus:border-primary-orange transition-colors"
                />
              </div>
            </div>

            {/* Teacher note */}
            <div className="bg-gradient-to-b from-primary-orange/10 to-primary-yellow/10 rounded-3xl p-6">
              <div className="w-10 h-10 flex items-center justify-center bg-primary-orange rounded-2xl mb-3">
                <i className="ri-graduation-cap-fill text-white text-xl"></i>
              </div>
              <h3 className="font-bold text-primary-brown-dark mb-4 text-lg">Dành cho Giáo viên</h3>
              <button
                onClick={handleTeacherClick}
                className="inline-flex items-center gap-2 text-base font-bold text-primary-orange hover:gap-3 transition-all cursor-pointer whitespace-nowrap"
              >
                Vào khu vực GV <i className="ri-arrow-right-line"></i>
              </button>
            </div>

            {/* Quick Tips */}
            <div className="bg-white rounded-3xl p-6">
              <h3 className="text-lg font-bold text-primary-brown-dark mb-4 flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-yellow/20 rounded-lg">
                  <i className="ri-lightbulb-fill text-primary-yellow"></i>
                </div>
                Gợi ý chia sẻ
              </h3>
              <div className="space-y-3">
                {[
                  { icon: 'ri-camera-line', text: 'Ảnh buổi học thú vị' },
                  { icon: 'ri-trophy-line', text: 'Thành tích nổi bật' },
                  { icon: 'ri-heart-line', text: 'Khoảnh khắc đáng nhớ' },
                  { icon: 'ri-question-line', text: 'Câu hỏi thảo luận' },
                ].map(tip => (
                  <button
                    key={tip.text}
                    onClick={() => setShowShareModal(true)}
                    className="flex items-center gap-3 w-full text-left px-3 py-2.5 rounded-xl hover:bg-primary-cream transition-colors cursor-pointer group"
                  >
                    <div className="w-8 h-8 flex items-center justify-center bg-primary-orange/10 rounded-lg group-hover:bg-primary-orange/20 transition-colors">
                      <i className={`${tip.icon} text-primary-orange`}></i>
                    </div>
                    <span className="text-base text-primary-brown">{tip.text}</span>
                  </button>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </section>

      <Footer />

      {showShareModal && (
        <ShareModal onClose={() => setShowShareModal(false)} onPost={handleAddPost} />
      )}

      {showTeacherModal && (
        <TeacherAccessModal onClose={() => setShowTeacherModal(false)} />
      )}

      {commentPostId && activeCommentPost && (
        <CommentsModal
          post={activeCommentPost}
          comments={activeCommentsList}
          onClose={() => setCommentPostId(null)}
          onAddComment={(comment) => handleAddComment(commentPostId, comment)}
        />
      )}

      {/* Edit Post Modal */}
      {editPostId && editPost && (
        <EditPostModal
          post={editPost}
          onClose={() => setEditPostId(null)}
          onSave={(content) => handleEditPost(editPostId, content)}
        />
      )}

      {/* Delete Confirm Modal */}
      {deleteConfirmId && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm">
          <div className="bg-white rounded-3xl max-w-sm w-full p-8 text-center">
            <div className="w-14 h-14 flex items-center justify-center bg-red-100 rounded-full mx-auto mb-4">
              <i className="ri-delete-bin-2-fill text-red-500 text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-primary-brown-dark mb-2">Xóa bài đăng?</h3>
            <p className="text-primary-brown-light text-sm mb-6">Bài đăng này sẽ bị xóa vĩnh viễn. Bạn có chắc chắn không?</p>
            <div className="flex gap-3">
              <button
                onClick={() => setDeleteConfirmId(null)}
                className="flex-1 py-3 border-2 border-primary-brown-light/20 rounded-xl text-primary-brown-light font-semibold cursor-pointer whitespace-nowrap"
              >
                Hủy
              </button>
              <button
                onClick={() => handleDeletePost(deleteConfirmId)}
                className="flex-1 py-3 bg-red-500 text-white font-bold rounded-xl hover:bg-red-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                Xóa ngay
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── CommentsModal ──────────────────────────────────────────────────────────────
function CommentsModal({
  post,
  comments,
  onClose,
  onAddComment,
}: {
  post: CommunityPost;
  comments: Comment[];
  onClose: () => void;
  onAddComment: (c: Comment) => void;
}) {
  const [text, setText] = useState('');
  const [role, setRole] = useState<'student' | 'teacher' | 'parent'>('student');

  const avatarMap: Record<'student' | 'teacher' | 'parent', string> = {
    student: 'https://readdy.ai/api/search-image?query=Cute%20chibi%20portrait%20of%20young%20Vietnamese%20student%2C%20cheerful%20smile%2C%20school%20uniform%2C%20simple%20round%20face%2C%20kawaii%20style%2C%20small%20icon%20size%2C%20cream%20background&width=80&height=80&seq=cmt-new-s&orientation=squarish',
    teacher: 'https://readdy.ai/api/search-image?query=Cute%20chibi%20portrait%20of%20Vietnamese%20teacher%2C%20warm%20smile%2C%20glasses%2C%20simple%20round%20face%2C%20kawaii%20style%2C%20small%20icon%20size%2C%20cream%20background&width=80&height=80&seq=cmt-new-t&orientation=squarish',
    parent: 'https://readdy.ai/api/search-image?query=Cute%20chibi%20portrait%20of%20Vietnamese%20parent%2C%20gentle%20smile%2C%20casual%20clothes%2C%20simple%20round%20face%2C%20kawaii%20style%2C%20small%20icon%20size%2C%20cream%20background&width=80&height=80&seq=cmt-new-p&orientation=squarish',
  };

  const nameMap: Record<'student' | 'teacher' | 'parent', string> = {
    student: 'Học sinh',
    teacher: 'Giáo viên',
    parent: 'Phụ huynh',
  };

  const handleSubmit = () => {
    if (!text.trim()) return;
    onAddComment({
      id: `c-${Date.now()}`,
      authorName: nameMap[role],
      authorRole: role,
      authorAvatar: avatarMap[role],
      content: text.trim(),
      createdAt: 'Vừa xong',
    });
    setText('');
  };

  const roleIcons: Record<'student' | 'teacher' | 'parent', string> = {
    student: 'ri-user-smile-fill',
    teacher: 'ri-graduation-cap-fill',
    parent: 'ri-parent-fill',
  };

  const roleBadgeColors: Record<'student' | 'teacher' | 'parent', string> = {
    student: 'bg-primary-yellow/20 text-primary-brown',
    teacher: 'bg-primary-orange/20 text-primary-orange',
    parent: 'bg-green-100 text-green-700',
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4 bg-black/40 backdrop-blur-sm">
      <div className="bg-white w-full sm:max-w-xl rounded-t-3xl sm:rounded-3xl flex flex-col max-h-[85vh]">
        {/* Header */}
        <div className="flex items-center justify-between px-6 pt-5 pb-4 border-b border-primary-brown-light/10 flex-shrink-0">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-orange/10 rounded-xl">
              <i className="ri-chat-1-fill text-primary-orange text-lg"></i>
            </div>
            <div>
              <h3 className="text-base font-bold text-primary-brown-dark">Bình luận</h3>
              <p className="text-xs text-primary-brown-light">{comments.length} bình luận</p>
            </div>
          </div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary-cream cursor-pointer">
            <i className="ri-close-line text-primary-brown-light text-lg"></i>
          </button>
        </div>

        {/* Post preview */}
        <div className="px-6 py-3 bg-primary-cream/50 border-b border-primary-brown-light/10 flex-shrink-0">
          <div className="flex items-center gap-2 mb-1">
            <img src={post.authorAvatar} alt={post.authorName} className="w-6 h-6 rounded-full object-cover object-top flex-shrink-0" />
            <span className="text-xs font-bold text-primary-brown-dark">{post.authorName}</span>
            <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${ROLE_COLORS[post.authorRole]}`}>{ROLE_LABELS[post.authorRole]}</span>
          </div>
          <p className="text-sm text-primary-brown-light line-clamp-2">{post.content}</p>
        </div>

        {/* Comments list */}
        <div className="flex-1 overflow-y-auto px-6 py-4 space-y-5">
          {comments.length === 0 ? (
            <div className="text-center py-10">
              <div className="w-14 h-14 flex items-center justify-center bg-primary-orange/10 rounded-full mx-auto mb-3">
                <i className="ri-chat-smile-2-line text-2xl text-primary-orange/50"></i>
              </div>
              <p className="text-sm text-primary-brown-light">Chưa có bình luận nào. Hãy là người đầu tiên!</p>
            </div>
          ) : comments.map(c => (
            <div key={c.id} className="flex gap-3">
              <img src={c.authorAvatar} alt={c.authorName} className="w-9 h-9 rounded-full object-cover object-top flex-shrink-0 mt-0.5" />
              <div className="flex-1">
                <div className="bg-primary-cream rounded-2xl rounded-tl-sm px-4 py-3">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-sm font-bold text-primary-brown-dark">{c.authorName}</span>
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${roleBadgeColors[c.authorRole]}`}>
                      {ROLE_LABELS[c.authorRole]}
                    </span>
                  </div>
                  <p className="text-sm text-primary-brown leading-relaxed">{c.content}</p>
                </div>
                <p className="text-xs text-primary-brown-light mt-1 px-1">{c.createdAt}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Composer */}
        <div className="px-6 py-4 border-t border-primary-brown-light/10 flex-shrink-0">
          {/* Role picker */}
          <div className="flex gap-2 mb-3">
            {(['student', 'teacher', 'parent'] as const).map(r => (
              <button
                key={r}
                onClick={() => setRole(r)}
                className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold border transition-all cursor-pointer whitespace-nowrap ${
                  role === r
                    ? 'bg-primary-orange text-white border-primary-orange'
                    : 'bg-primary-cream text-primary-brown-light border-primary-brown-light/20 hover:border-primary-orange/50'
                }`}
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={roleIcons[r]}></i>
                </div>
                {nameMap[r]}
              </button>
            ))}
          </div>
          <div className="flex items-end gap-3">
            <div className="w-9 h-9 flex-shrink-0 rounded-full bg-primary-orange/15 flex items-center justify-center">
              <i className={`${roleIcons[role]} text-primary-orange text-base`}></i>
            </div>
            <div className="flex-1 relative">
              <textarea
                value={text}
                onChange={e => setText(e.target.value.slice(0, 500))}
                placeholder="Viết bình luận của bạn..."
                rows={2}
                className="w-full px-4 py-2.5 rounded-2xl border border-primary-brown-light/20 bg-primary-cream text-sm resize-none focus:outline-none focus:border-primary-orange transition-colors text-primary-brown-dark placeholder-primary-brown-light"
              />
              {text.length > 450 && (
                <span className="absolute right-3 bottom-2 text-xs text-primary-orange/70">{500 - text.length}</span>
              )}
            </div>
            <button
              onClick={handleSubmit}
              disabled={!text.trim()}
              className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-primary-orange rounded-full text-white hover:bg-primary-orange/90 transition-all cursor-pointer disabled:opacity-40"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-send-plane-fill text-base"></i>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function ShareModal({ onClose, onPost }: { onClose: () => void; onPost?: (post: CommunityPost) => void }) {
  const [content, setContent] = useState('');
  const [role, setRole] = useState<'student' | 'teacher' | 'parent'>('student');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = () => {
    if (!content.trim()) return;
    const tags = (content.match(/#\w+/g) || []).map(t => t.slice(1));
    if (tags.length === 0) tags.push('chia-se');
    const newPost: CommunityPost = {
      id: `user-post-${Date.now()}`,
      authorName: role === 'student' ? 'Học sinh' : role === 'teacher' ? 'Giáo viên' : 'Phụ huynh',
      authorRole: role,
      authorAvatar: 'https://readdy.ai/api/search-image?query=simple%20flat%20cartoon%20user%20avatar%20friendly%20warm%20face%20circle%20portrait%20illustration%20minimal%20style%20orange%20brown%20tones&width=100&height=100&seq=user-avatar-default-v1&orientation=squarish',
      createdAt: 'Vừa đăng',
      content: content.trim(),
      tags,
      likes: 0,
      comments: 0,
    };
    onPost?.(newPost);
    setSubmitted(true);
    setTimeout(onClose, 2000);
  };

  const roleOptions: { value: 'student' | 'teacher' | 'parent'; label: string; icon: string; color: string; active: string }[] = [
    { value: 'student', label: 'Học sinh', icon: 'ri-user-smile-fill', color: 'border-primary-yellow/40 text-primary-brown', active: 'bg-primary-yellow/20 border-primary-yellow text-primary-brown font-bold' },
    { value: 'teacher', label: 'Giáo viên', icon: 'ri-graduation-cap-fill', color: 'border-primary-orange/30 text-primary-brown', active: 'bg-primary-orange/15 border-primary-orange text-primary-orange font-bold' },
    { value: 'parent', label: 'Phụ huynh', icon: 'ri-parent-fill', color: 'border-green-300/40 text-primary-brown', active: 'bg-green-100 border-green-400 text-green-700 font-bold' },
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-3xl max-w-lg w-full p-8">
        {submitted ? (
          <div className="text-center py-8">
            <div className="w-16 h-16 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4">
              <i className="ri-check-fill text-3xl text-green-500"></i>
            </div>
            <h3 className="text-xl font-bold text-primary-brown-dark mb-2">Đã đăng!</h3>
            <p className="text-primary-brown-light text-base">Cảm ơn bạn đã chia sẻ!</p>
          </div>
        ) : (
          <>
            <div className="flex items-center justify-between mb-5">
              <h3 className="text-xl font-bold text-primary-brown-dark">Chia sẻ khoảnh khắc</h3>
              <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary-cream cursor-pointer">
                <i className="ri-close-line text-primary-brown-light"></i>
              </button>
            </div>

            {/* Role selector */}
            <div className="mb-4">
              <p className="text-sm font-semibold text-primary-brown-dark mb-2">Bạn là:</p>
              <div className="flex gap-2">
                {roleOptions.map(opt => (
                  <button
                    key={opt.value}
                    onClick={() => setRole(opt.value)}
                    className={`flex-1 flex flex-col items-center gap-1.5 py-3 px-2 rounded-xl border-2 transition-all cursor-pointer ${role === opt.value ? opt.active : `bg-primary-cream ${opt.color} hover:opacity-80`}`}
                  >
                    <div className="w-7 h-7 flex items-center justify-center">
                      <i className={`${opt.icon} text-xl`}></i>
                    </div>
                    <span className="text-xs whitespace-nowrap">{opt.label}</span>
                  </button>
                ))}
              </div>
            </div>

            <textarea
              value={content}
              onChange={e => setContent(e.target.value.slice(0, 1000))}
              placeholder="Chia sẻ khoảnh khắc của bạn về trò chơi dân gian Bahnar..."
              className="w-full h-36 px-4 py-3 rounded-2xl border border-primary-brown-light/20 bg-primary-cream text-base resize-none focus:outline-none focus:border-primary-orange transition-colors text-primary-brown-dark"
            />
            <div className="flex items-center justify-between mt-2 mb-5">
              <span className="text-sm text-primary-brown-light">{content.length}/1000 ký tự</span>
              {content.length > 950 && (
                <span className="text-xs text-primary-orange">{1000 - content.length} ký tự còn lại</span>
              )}
            </div>
            <div className="flex gap-3">
              <button onClick={onClose} className="flex-1 py-3 border-2 border-primary-brown-light/20 rounded-xl text-primary-brown-light font-semibold cursor-pointer whitespace-nowrap">
                Hủy
              </button>
              <button
                onClick={handleSubmit}
                disabled={!content.trim()}
                className="flex-1 py-3 bg-gradient-to-r from-primary-orange to-primary-yellow text-white font-bold rounded-xl hover:opacity-90 transition-all cursor-pointer whitespace-nowrap disabled:opacity-40"
              >
                Đăng bài
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

function TeacherAccessModal({ onClose }: { onClose: () => void }) {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState('');
  const [mode, setMode] = useState<'login' | 'forgot' | 'verify' | 'reset'>('login');
  const [contact, setContact] = useState('');
  const [verifyCode, setVerifyCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [showNewPass, setShowNewPass] = useState(false);
  const [resetDone, setResetDone] = useState(false);

  const handleSubmit = () => {
    if (password === 'TCDGBahnar') {
      localStorage.setItem('teacher_authenticated', 'true');
      navigate('/teacher');
      onClose();
    } else {
      setError('Mật khẩu không đúng. Vui lòng thử lại.');
    }
  };

  const handleSendCode = () => {
    if (!contact.trim()) return;
    setMode('verify');
  };

  const handleVerify = () => {
    if (!verifyCode.trim()) return;
    setMode('reset');
  };

  const handleResetPassword = () => {
    if (!newPassword.trim()) return;
    setResetDone(true);
    setTimeout(() => {
      setMode('login');
      setResetDone(false);
      setContact('');
      setVerifyCode('');
      setNewPassword('');
    }, 2000);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-3xl max-w-md w-full p-8">
        {mode === 'login' && (
          <>
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-orange/10 rounded-2xl">
                  <i className="ri-lock-2-fill text-primary-orange text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-primary-brown-dark">Khu vực Giáo viên</h3>
              </div>
              <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary-cream cursor-pointer">
                <i className="ri-close-line text-primary-brown-light text-lg"></i>
              </button>
            </div>
            <p className="text-sm text-primary-brown-light mb-5">Vui lòng nhập mật khẩu để truy cập khu vực giáo viên.</p>
            <div className="relative mb-2">
              <input
                type={showPass ? 'text' : 'password'}
                value={password}
                onChange={e => { setPassword(e.target.value); setError(''); }}
                onKeyDown={e => e.key === 'Enter' && handleSubmit()}
                placeholder="Nhập mật khẩu..."
                className="w-full pr-11 pl-4 py-3 rounded-xl border border-primary-brown-light/20 bg-primary-cream text-base text-primary-brown-dark placeholder-primary-brown-light focus:outline-none focus:border-primary-orange transition-colors"
              />
              <button
                onClick={() => setShowPass(!showPass)}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-7 h-7 flex items-center justify-center text-primary-brown-light hover:text-primary-orange cursor-pointer"
              >
                <i className={showPass ? 'ri-eye-off-line' : 'ri-eye-line'}></i>
              </button>
            </div>
            {error && <p className="text-sm text-red-500 mb-2">{error}</p>}
            <button
              onClick={() => setMode('forgot')}
              className="text-sm text-primary-orange hover:underline cursor-pointer mb-5 block"
            >
              Quên mật khẩu?
            </button>
            <div className="flex gap-3">
              <button onClick={onClose} className="flex-1 py-3 border-2 border-primary-brown-light/20 rounded-xl text-primary-brown-light font-semibold cursor-pointer whitespace-nowrap">
                Hủy
              </button>
              <button
                onClick={handleSubmit}
                disabled={!password.trim()}
                className="flex-1 py-3 bg-gradient-to-r from-primary-orange to-primary-yellow text-white font-bold rounded-xl hover:opacity-90 transition-all cursor-pointer whitespace-nowrap disabled:opacity-40"
              >
                Vào khu vực GV
              </button>
            </div>
          </>
        )}

        {mode === 'forgot' && (
          <>
            <button
              onClick={() => setMode('login')}
              className="flex items-center gap-1.5 text-sm text-primary-brown-light hover:text-primary-orange cursor-pointer mb-5"
            >
              <i className="ri-arrow-left-line"></i> Quay lại
            </button>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 flex items-center justify-center bg-primary-orange/10 rounded-2xl">
                <i className="ri-lock-unlock-line text-primary-orange text-xl"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-primary-brown-dark">Quên mật khẩu</h3>
              </div>
            </div>
            <p className="text-sm text-primary-brown-light mb-4">
              Nhập số điện thoại hoặc email - chúng mình sẽ gửi mã xác nhận để đặt lại mật khẩu.
            </p>
            <input
              type="text"
              value={contact}
              onChange={e => setContact(e.target.value)}
              placeholder="Số điện thoại hoặc email"
              className="w-full px-4 py-3 rounded-xl border border-primary-brown-light/20 bg-primary-cream text-sm text-primary-brown-dark placeholder-primary-brown-light focus:outline-none focus:border-primary-orange transition-colors mb-4"
            />
            <button
              onClick={handleSendCode}
              disabled={!contact.trim()}
              className="w-full py-3 bg-gradient-to-r from-primary-orange to-primary-yellow text-white font-bold rounded-xl hover:opacity-90 transition-all cursor-pointer whitespace-nowrap disabled:opacity-40"
            >
              Gửi mã xác nhận
            </button>
          </>
        )}

        {mode === 'verify' && (
          <>
            <button
              onClick={() => setMode('forgot')}
              className="flex items-center gap-1.5 text-sm text-primary-brown-light hover:text-primary-orange cursor-pointer mb-5"
            >
              <i className="ri-arrow-left-line"></i> Quay lại
            </button>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 flex items-center justify-center bg-green-100 rounded-2xl">
                <i className="ri-mail-send-line text-green-500 text-xl"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-primary-brown-dark">Nhập mã xác nhận</h3>
                <p className="text-xs text-primary-brown-light">Mã đã gửi đến {contact}</p>
              </div>
            </div>
            <p className="text-sm text-primary-brown-light mb-4">Kiểm tra tin nhắn hoặc email và nhập mã 6 số.</p>
            <input
              type="text"
              value={verifyCode}
              onChange={e => setVerifyCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
              placeholder="Nhập mã 6 số"
              className="w-full px-4 py-3 rounded-xl border border-primary-brown-light/20 bg-primary-cream text-center text-lg tracking-widest font-bold text-primary-brown-dark placeholder-primary-brown-light focus:outline-none focus:border-primary-orange transition-colors mb-4"
            />
            <button
              onClick={handleVerify}
              disabled={verifyCode.length < 4}
              className="w-full py-3 bg-gradient-to-r from-primary-orange to-primary-yellow text-white font-bold rounded-xl hover:opacity-90 transition-all cursor-pointer whitespace-nowrap disabled:opacity-40"
            >
              Xác nhận mã
            </button>
          </>
        )}

        {mode === 'reset' && (
          <>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 flex items-center justify-center bg-primary-orange/10 rounded-2xl">
                <i className="ri-lock-password-line text-primary-orange text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-primary-brown-dark">Đặt mật khẩu mới</h3>
            </div>
            {resetDone ? (
              <div className="text-center py-6">
                <div className="w-14 h-14 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-3">
                  <i className="ri-check-fill text-2xl text-green-500"></i>
                </div>
                <p className="font-bold text-primary-brown-dark">Đặt lại thành công!</p>
                <p className="text-sm text-primary-brown-light mt-1">Bạn có thể đăng nhập với mật khẩu mới.</p>
              </div>
            ) : (
              <>
                <div className="relative mb-4">
                  <input
                    type={showNewPass ? 'text' : 'password'}
                    value={newPassword}
                    onChange={e => setNewPassword(e.target.value)}
                    placeholder="Mật khẩu mới"
                    className="w-full pr-11 pl-4 py-3 rounded-xl border border-primary-brown-light/20 bg-primary-cream text-sm text-primary-brown-dark placeholder-primary-brown-light focus:outline-none focus:border-primary-orange transition-colors"
                  />
                  <button
                    onClick={() => setShowNewPass(!showNewPass)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 w-7 h-7 flex items-center justify-center text-primary-brown-light hover:text-primary-orange cursor-pointer"
                  >
                    <i className={showNewPass ? 'ri-eye-off-line' : 'ri-eye-line'}></i>
                  </button>
                </div>
                <button
                  onClick={handleResetPassword}
                  disabled={!newPassword.trim()}
                  className="w-full py-3 bg-gradient-to-r from-primary-orange to-primary-yellow text-white font-bold rounded-xl hover:opacity-90 transition-all cursor-pointer whitespace-nowrap disabled:opacity-40"
                >
                  Xác nhận mật khẩu mới
                </button>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}

function EditPostModal({ post, onClose, onSave }: { post: CommunityPost; onClose: () => void; onSave: (content: string) => void }) {
  const [content, setContent] = useState(post.content);

  const handleSave = () => {
    if (!content.trim()) return;
    onSave(content.trim());
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-3xl max-w-lg w-full p-8">
        <div className="flex items-center justify-between mb-5">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center bg-primary-orange/10 rounded-2xl">
              <i className="ri-edit-2-fill text-primary-orange text-xl"></i>
            </div>
            <h3 className="text-xl font-bold text-primary-brown-dark">Chỉnh sửa bài đăng</h3>
          </div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary-cream cursor-pointer">
            <i className="ri-close-line text-primary-brown-light"></i>
          </button>
        </div>

        <textarea
          value={content}
          onChange={e => setContent(e.target.value.slice(0, 1000))}
          rows={5}
          className="w-full px-4 py-3 rounded-2xl border border-primary-brown-light/20 bg-primary-cream text-base resize-none focus:outline-none focus:border-primary-orange transition-colors text-primary-brown-dark mb-2"
        />
        <div className="flex items-center justify-between mb-5">
          <span className="text-sm text-primary-brown-light">{content.length}/1000 ký tự</span>
        </div>

        <div className="flex gap-3">
          <button onClick={onClose} className="flex-1 py-3 border-2 border-primary-brown-light/20 rounded-xl text-primary-brown-light font-semibold cursor-pointer whitespace-nowrap">
            Hủy
          </button>
          <button
            onClick={handleSave}
            disabled={!content.trim()}
            className="flex-1 py-3 bg-gradient-to-r from-primary-orange to-primary-yellow text-white font-bold rounded-xl hover:opacity-90 transition-all cursor-pointer whitespace-nowrap disabled:opacity-40"
          >
            Lưu thay đổi
          </button>
        </div>
      </div>
    </div>
  );
}
